import React from "react"
import { withStyles } from '@material-ui/core/styles';
import { navigate } from "gatsby"
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import { Button, Tabs, Tab, Typography, Box, Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import SaThumb from './svg/sa-thumb'
import QpThumb from './svg/qp-thumb'
import { useTranslation } from "react-i18next"
import { defaultStaticContext } from '../context/StaticContext'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const DesignSelect = ({ changeSide, updateDesign, updateMetaInfo, gotoCompStage, currentMetaInfo, currentProduct, defaultDesign, title, currentID, updateID, posts, resetAll, updateEditIndex, updateTag, outofstock, currentRegion, currentLang }) => {
  const theme = useTheme();
  const [tab, setTab] = React.useState(0);
  const [myDesignArray, setDesignArray] = React.useState([]);

  const DesignInfo = () => (
    <div className={"design " + currentLang}>
      <p className="small">{ t('product.designBy') } <strong>{currentMetaInfo.title}</strong></p>
      <p><strong>1. { t('product.questions')[0] }</strong></p>
      <p className="en">{currentMetaInfo.answer1_en}</p>
      <p className="tc">{currentMetaInfo.answer1_tc}</p>
      <p className="jp">{currentMetaInfo.answer1_jp}</p>
      <p><strong>2. { t('product.questions')[1] }</strong></p>
      <p className="en">{currentMetaInfo.answer2_en}</p>
      <p className="tc">{currentMetaInfo.answer2_tc}</p>
      <p className="jp">{currentMetaInfo.answer2_jp}</p>
    </div>
  )

  const ProductInfo = () => (
    <div className="info">
      { currentProduct === 'sacoche' ? (
        <>
          <p>{ t('product.sacoche')['productDesc'] }</p>
          <ul>
            { (t('product.sacoche')['productContent'] ? t('product.sacoche')['productContent'] : []).map((content, index) => (
              <li key={index}>{content}</li>
            ))}
          </ul>
          <p>{ t('product.sacoche')['size'] }</p>
          <ul>
            { (t('product.sacoche')['productInfo'] ? t('product.sacoche')['productInfo'] : []).map((content, index) => (
              <li key={index}>{content.name}: {content.parameter}</li>
            ))}
          </ul>
        </>
      ) : (
        <>
          <p>{ t('product.quick-pocket')['productDesc'] }</p>
          <ul>
            { (t('product.quick-pocket')['productContent'] ? t('product.quick-pocket')['productContent'] : []).map((content, index) => (
              <li key={index}>{content}</li>
            ))}
          </ul>
          <p>{ t('product.quick-pocket')['size'] }</p>
          <ul>
            { (t('product.quick-pocket')['productContent'] ? t('product.quick-pocket')['productInfo'] : []).map((content, index) => (
              <li key={index}>{content.name}: {content.parameter}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  )

  React.useEffect(() => {
    const isBrowser = typeof window !== 'undefined';
    let designarray
    if (isBrowser) {
      designarray = localStorage.getItem('myDesign') ? JSON.parse(localStorage.getItem('myDesign')) : []
      setDesignArray(designarray.reverse())
    }
    const filterDesignArry = designarray.filter(design => {
      return design.product === currentProduct;
    });
    if (filterDesignArry.length) {
      setTab(1)
    } else {
      setTab(0)
    }
    updateTag('')
  }, []);

  const updateInspiration = (index) => {
    const item = {
      product: '',
      case: [],
      tag: ''
    }
    item.case = defaultStaticContext.design[currentProduct][index].case
    item.product = currentProduct

    // item.tag = currentTag
    updateDesign(item);
    updateID('inspiration' + index)
  }

  const handleChangeIndex = (event, newValue) => {
    setTab(newValue);
    if (newValue === 0 && currentID[0] === 'm') {
      updateID('inspiration0')
    } else if (newValue === 1 && currentID[0] === 'i') {
      updateID('mydesign0')
    }
  };

  const saveImage = () => {
    function drawInlineSVG(svgElement, svgContainer){
      var svgURL = new XMLSerializer().serializeToString(svgElement);
      var img  = new Image();
      var encodedData = window.btoa(svgURL);
      img.src = 'data:image/svg+xml;base64,'+ encodeURIComponent(encodedData);
      img.crossOrigin = 'Anonymous';
      svgContainer.innerHTML = ""
      svgContainer.appendChild(img)
    }
    drawInlineSVG(document.querySelector('#front'), document.querySelector('#canvas-container-front'))
    drawInlineSVG(document.querySelector('#back'), document.querySelector('#canvas-container-back'))
  }

  const [expanded, setExpanded] = React.useState('panel1');

  const handleChangePanel = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const ProductExpansionPanel = withStyles({
    root: {
      borderTop: '1px solid #979797',
      borderBottom: '1px solid #979797',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      '&:last-child': {
        borderRadius: 0,
      },
      '&:not(:last-child)': {
        borderBottom: 0,
      },
      '&:before': {
        display: 'none',
      },
      '&$expanded': {
        margin: 'auto',
      },
    },
    expanded: {},
  })(Accordion);

  const ProductExpansionPanelSummary = withStyles({
    root: {
      padding: 0,
      fontSize: `1.25rem`,
      fontWeight: 500,
      minHeight: `auto`,
      '&$expanded': {
        minHeight: `auto`,
      }
    },
    content: {
      margin: 0,
      fontSize: `16px`,
      fontWeight: 700,
      '&$expanded': {
        margin: 0,
      }
    },
    expanded: {},
  })(AccordionSummary);

  const ProductExpansionPanelDetails = withStyles({
    root: {
      padding: 0,
      fontSize: `0.875rem`
    }
  })(AccordionDetails);

  const scrollableNodeRef = React.useRef(null);

  const scrollNavigation = (move) => {
    scrollableNodeRef.current.scrollTo({
      left: scrollableNodeRef.current.scrollLeft + move,
      behavior: 'smooth'
    });
  }

  const { t } = useTranslation()

  return (
    <div className="designSelect">
      <div className="desktop designSelect__header">
        <h2>{title}</h2>
        <div className="price">{defaultStaticContext.price[currentRegion]['unit']} {defaultStaticContext.price[currentRegion][currentProduct]}</div>
      </div>
      <Tabs
        value={tab}
        onChange={handleChangeIndex}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
        aria-label="full width tabs example"
      >
        <Tab label={ t('product.inspiration') } {...a11yProps(0)} />
        <Tab label={ t('product.myDesign') } {...a11yProps(1)} />
      </Tabs>
      <TabPanel
        value={tab}
        index={0}
        dir={theme.direction}
        className="tabContainer"
        >
        <div className="scrollButton-container" ref={scrollableNodeRef}>
          {defaultStaticContext.design[currentProduct].map((item, index) => {
            return (
              <div key={index} className="button__container">
                <Button
                  className={currentID === ('inspiration' + index) ? 'active' : ''}
                  onClick={() => {updateInspiration(index); changeSide('front')}}
                  key={'inspiration' + index}>
                  { currentProduct === 'sacoche' ? (
                    <SaThumb currentDesign={item.case} />
                  ) : (
                    <QpThumb currentDesign={item.case} />
                  )}
                  <span
                    className="button__overlay"
                    style={{display: currentID === ('inspiration' + index) ? 'flex' : 'none'}}
                  >
                    <span onClick={() => {gotoCompStage(); }}>{ t('product.useDesign') }</span>
                  </span>
                </Button>
                <span>{item.name}</span>
              </div>
              )
          })}
        </div>
        <button onClick={() => scrollNavigation(-240)} className="scrollButton-prev"><i className="icon icon-prevs"/></button>
        <button onClick={() => scrollNavigation(240)} className="scrollButton-next"><i className="icon icon-nexts"/></button>
        <p className="fade small">{ t('product.customDesc') }</p>
        {/* <ProductExpansionPanel expanded={expanded === 'panel1'} onChange={handleChangePanel('panel1')}>
          <ProductExpansionPanelSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            { t('product.aboutDesign') }
          </ProductExpansionPanelSummary>
          <ProductExpansionPanelDetails>
            <DesignInfo />
          </ProductExpansionPanelDetails>
        </ProductExpansionPanel> */}
        {/* <ProductExpansionPanel expanded={expanded === 'panel2'} onChange={handleChangePanel('panel2')}>
          <ProductExpansionPanelSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            { t('product.aboutBag') }
          </ProductExpansionPanelSummary>
          <ProductExpansionPanelDetails>
            <ProductInfo />
          </ProductExpansionPanelDetails>
        </ProductExpansionPanel> */}
        <h3>{ t('product.aboutBag') }</h3>
        <ProductInfo />
      </TabPanel>
      <TabPanel
        value={tab}
        index={1}
        dir={theme.direction}
        className="tabContainer">
        <div className="scrollButton-container">
          { myDesignArray.map((design, index) =>
            <div key={index} className="button__container" style={{ display: design.product === currentProduct ? "display" : "none"}}>
              <Button
                className={currentID === ('mydesign' + index) ? 'active' : ''}
                onClick={() => {updateDesign(design); updateID('mydesign' + index)}}
                key={'mydesign' + index}>
                  { currentProduct === 'sacoche' ? (
                    <SaThumb currentDesign={design.case} />
                  ) : (
                    <QpThumb currentDesign={design.case} />
                  )}
                <span
                  className="button__overlay"
                  style={{display: currentID === ('mydesign' + index) ? 'flex' : 'none'}}
                >
                  <span onClick={() => {gotoCompStage(); updateEditIndex(myDesignArray.length - index - 1)}}>{t('product.editDesign')}</span>
                </span>
              </Button>
              <span>{t('product.design') + ' ' + (myDesignArray.length - index)}</span>
            </div>
          )}
          <div className="button__container button__create">
            <Button
              onClick={() => {gotoCompStage(); resetAll()}}>
                <i className="icon icon-create" />
            </Button>
            <span className="fade">{t('product.createNew')}</span>
          </div>
        </div>
        <p className="fade small">{ t('product.customDesc') }</p>
        <h3>{ t('product.aboutBag') }</h3>
        <ProductInfo />
      </TabPanel>
      <div className="buttonGroup stickToBottom">
        { (defaultStaticContext.mode !== 'post-launch' && defaultStaticContext.mode !== 'pre-launch') && (
          <Button
            className="basicButton outline"
            onClick={() => {
              navigate(
                "/checkout",
                {
                  state: { outofstock: false },
                }
              )
              saveImage()
            }}
          >
            {t('product.reserve')}
          </Button>
        )}
        
        {tab === 0 ? (
          <Button className="basicButton" onClick={gotoCompStage}>
            { t('product.customise') } <i className="icon icon-edit"/>
          </Button>
        ) : (
          <Button className="basicButton" onClick={() => {gotoCompStage(); resetAll()}}>
            {t('product.createNew')} <i className="icon icon-edit"/>
          </Button>
        )}
      </div>
    </div>
  )
}

export default DesignSelect

